import Vue from 'vue'
import Vuex from 'vuex'
import readingsRef from '@/utils/firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    readings: []
  },
  mutations: {
    updateReadings(state, payload) {
      state.readings = payload
    }
  },
  actions: {
    async getReadings({ commit }) {
      const firestore = readingsRef.firestore()
      const qrCodeReadingRef = firestore.collection('qr-code-readings')
      let updatedReadings = []
      qrCodeReadingRef.onSnapshot(snap => {
        updatedReadings = []
        snap.forEach(doc => {
          console.log(doc)
          updatedReadings.push(doc.data())
        })
        updatedReadings.sort((a, b) => b.created_at - a.created_at)
        commit('updateReadings', updatedReadings)
      })
    }
  },
  modules: {}
})
